import { render } from "./NewebPayCustomerReturn.vue?vue&type=template&id=0ba67e4a&scoped=true"
import script from "./NewebPayCustomerReturn.vue?vue&type=script&lang=js"
export * from "./NewebPayCustomerReturn.vue?vue&type=script&lang=js"

import "./NewebPayCustomerReturn.vue?vue&type=style&index=0&id=0ba67e4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba67e4a"]])

export default __exports__